import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Toast from "react-native-toast-message";
import { useNavigation, useRoute } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import { navigate } from "expo-router/build/global-state/routing";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const TableTransactionHistoryScreen = () => {
  const [tableTransactData, setTableTransactData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigation = useNavigation();

  const route = useRoute();

  const { tableID } = route.params;

  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    getTableTransactions();
  }, []);

  const getTableTransactions = async () => {
    setIsLoading(true);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.get(`/getTableTransfers/getTableTransfers${tableID}`);

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('Table TransactionLists:', response.data.transactions);

        setTableTransactData(response.data.transactions);

        // Toast.show({
        //     type: 'success',
        //     text1: 'Success',
        //     text2: response.data.message,
        // })

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: "Unexpected response",
        });
      }
    } catch (error) {
      if (error.response) {
        // //console.error('Error response from server:', error.response.data);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: error.response.data.message,
        });
      } else if (error.request) {
        //console.error('No response received:', error.request);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: "No response received",
        });
      } else {
        //console.error('Error setting up the request:', error.message);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: error.message,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return ""; // Handle empty or undefined input

    const date = new Date(isoString);

    if (isNaN(date)) return ""; // Handle invalid dates

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // Use short month name (e.g., Jun)
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2-digit minutes
    const period = hours >= 12 ? "PM" : "AM"; // AM/PM format
    const formattedHour = hours % 12 || 12; // Convert to 12-hour format

    // Function to add suffix (st, nd, rd, th) to the day
    const getDayWithSuffix = (day) => {
      if (day > 3 && day < 21) return `${day}th`; // Special case for 11-13
      switch (day % 10) {
        case 1:
          return `${day}st`;
        case 2:
          return `${day}nd`;
        case 3:
          return `${day}rd`;
        default:
          return `${day}th`;
      }
    };

    return {
      date: `${getDayWithSuffix(day)} ${month} ${year}`,
      time: `${formattedHour}:${minutes} ${period}`,
    };
  };

  if (isLoading) {
    return (
      <View style={{ flex: 1, paddingTop: "20%" }}>
        <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <SafeAreaView>
      <TopHeaderComponent
        headerText={"Table Transaction History"}
        hideScreen={() => navigation.goBack()}
      />
      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: 100,
          backgroundColor: Colours.LIGHTEST,
        }}
      >
        {tableTransactData && tableTransactData.length > 0 ? (
          <View style={styles.bodyContainer}>
            <View style={styles.giverHeaders}>
              <Text style={styles.transactionHistoryTxt}>TRANSACTION HISTORY</Text>
            </View>
            <FlatList
              data={tableTransactData}
              scrollEnabled={false}
              keyExtractor={(history) => history._id}
              renderItem={({ item: history }) => (
                <TouchableOpacity style={styles.tablesListContainer2} onPress={() => {}}>
                  <View style={styles.profileContainer}>
                    <View style={styles.profileSubContainer}>
                      {/* <Image source={{ uri: pulls?.userID?.profilePicture }} style={styles.userImage} /> */}
                      {/* // <Image source={require('../../../assets/imagePlaceholder.jpg')} style={styles.userImage} />} */}
                      {/* <Text style={{ fontSize: 12, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }} >BY: {pulls?.creatorName}</Text> */}
                      <Text style={styles.userRealNamesTxt}>FROM: {history?.transactionFrom}</Text>
                      <Text style={styles.transactionToTxt}>TO: {history?.transactionTo}</Text>
                    </View>
                    <View>
                      {/* <Text style={{ fontSize: 11, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }} >25th June 2021</Text>
                                        <Text style={{ fontSize: 10, color: Colours.PRIMARY, fontFamily: 'Sen-Regular', textAlign: 'right' }} >2:40pm</Text> */}
                      <Text style={styles.dateTxt}>{formatDate(history?.createdAt).date}</Text>
                      <Text style={styles.timeTxt}>{formatDate(history?.createdAt).time}</Text>
                    </View>
                  </View>

                  <View style={styles.tableListTitlesContain}>
                    <View style={{ display: "flex", gap: 4 }}>
                      <Text style={styles.amountTxt}>
                        Amount
                        <Text style={styles.ngnTxt}> ₦{history?.amount.toLocaleString()}</Text>
                      </Text>
                      <Text style={styles.reasonTxt}>{history?.reason}</Text>
                      <View style={styles.tableValueContainer}>
                        <View style={styles.pullValueContainer}>
                          {/* <Text style={{ color: Colours.DARKLIGHTGRAY, fontSize: 12, fontFamily: 'Sen-Regular' }}>Bal:</Text>
                                                <Text style={{ color: Colours.PRIMARY, fontFamily: 'Sen-Bold' }}>  ₦{Number(history?.walletNewBalance)?.toLocaleString()}</Text> */}
                          <Text style={styles.transactTypeTxt}>{history?.transactionType} </Text>
                          <Text style={styles.transactTagTxt}>{history?.transactionTag}</Text>
                        </View>
                      </View>
                    </View>
                    {/* <Image source={{ uri: pulls?.image }}
                                                      style={styles.partyImgSmall} /> */}
                  </View>
                  <View
                    style={{
                      height: 1,
                      backgroundColor: Colours.LIGHTGRAY,
                      marginVertical: 5,
                      marginBottom: 10,
                    }}
                  />
                </TouchableOpacity>
              )}
            />
          </View>
        ) : (
          ""
        )}
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    margin: dynamicSpacing(15),
    marginBottom: 0,
    padding: dynamicSpacing(15),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
    shadowColor: "#E8E8E8",
  },
  transactionHistoryTxt: {
    paddingBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(15),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },
  userRealNamesTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  transactionToTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
  },
  dateTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
  },
  timeTxt: {
    fontSize: dynamicFontSize(11),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
    textAlign: "right",
  },
  amountTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
    width: "55%", // Changed from fixed 200px
  },
  ngnTxt: {
    color: Colours.PRIMARY,
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
  },
  reasonTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Regular",
    // width: '70%', // Changed from fixed 200px
  },
  transactTypeTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  transactTagTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  giverHeaders: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tablesListContainer2: {
    paddingBottom: dynamicSpacing(10),
    gap: dynamicSpacing(2),
  },
  profileContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: dynamicSpacing(5),
    gap: dynamicSpacing(5),
  },
  profileSubContainer: {
    display: "flex",
    gap: dynamicSpacing(5),
  },
  tableListTitlesContain: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // width: '60%', // Adjusted for responsiveness
    gap: dynamicSpacing(2),
  },
  pullValueContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(10),
    // width: '35%', // Adjusted for responsiveness
  },
  tableValueContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    //  width: '35%', // Adjusted for responsiveness
  },
});

export default TableTransactionHistoryScreen;
